export enum IDFShippingMode {
  TEST = "test",
  PRODUCTION = "production",
}
